// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [2];

export const dictionary = {
		"/": [3],
		"/atribucion": [4],
		"/auxilio": [5],
		"/buscar": [~6],
		"/datos": [7],
		"/mapa": [8],
		"/mensaje/[token]": [~9],
		"/moderar": [~10,[2]],
		"/moderar/login": [~11,[2]],
		"/offline": [12],
		"/persona/[id]": [~13],
		"/privacidad": [14],
		"/privacidad/eliminar": [15],
		"/punto/[id]": [~16],
		"/reencuentros": [~17],
		"/reportar": [18],
		"/reportar/a-salvo": [19],
		"/reportar/avistamiento": [20],
		"/reportar/condicion-medica": [21],
		"/reportar/cuerpo-nn": [22],
		"/reportar/desaparecido": [23],
		"/reportar/punto-ayuda": [24],
		"/reportar/refugio": [25]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);